// ANGEL FLIGHT — world↔Three coordinate adapter (pure, unit-tested).
//
// The simulation world is (x lateral m, z depth m forward, y height m up), with
// the gunner conceptually at the origin and enemies closing as z decreases
// toward strikeZ. Three.js is Y-up, right-handed, camera looking down -Z by
// default. We map depth so that GREATER world-z is FARTHER from the camera:
//
//   Three.X =  world.x      (lateral, +x = right)
//   Three.Y =  world.y      (height, ground = 0)
//   Three.Z = -world.z      (depth: far spawns at large -Z, near edge toward 0)
//
// This single sign flip (Z = -z) is the classic place for a flipped-depth bug,
// so it is isolated here and locked by coords.test.ts.

import type { WorldPos } from '../core/types';

export interface Vec3Like {
  x: number;
  y: number;
  z: number;
}

/** World position → Three.js scene coordinates. */
export function worldToThree(p: WorldPos): Vec3Like {
  return { x: p.x, y: p.y, z: -p.z };
}

/** Write a world position into an existing Three.Vector3-like target (no alloc). */
export function setFromWorld<T extends Vec3Like>(target: T, p: WorldPos): T {
  target.x = p.x;
  target.y = p.y;
  target.z = -p.z;
  return target;
}
